export const getTagsForList = <T extends string>(
	type: T,
	items?: Array<{ id: string }>
) => [
	...(items?.map(({ id }) => ({ type, id }) as const) ?? []),
	{ type, id: 'LIST' },
];
